export default __webpack_public_path__ + "static/media/twitter.898d9476.svg";